import { Status } from '../../constants/Enums'
import { Injectable } from '@angular/core';


@Injectable()
export class GlobalService {
  statusList: any = [];
  loadStatus() {
    return Status;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/global/global.service.ts